import { useEffect, useRef } from 'react'
import { get } from 'lodash'

// This hook schedules an api call in advance, is used when polling for updates
const useScheduleAction = ({ currentPageTemplate, error, ...rest }) => {
  const latestProps = useRef({ ...rest })
  useEffect(() => {
    const { delay_in_ms, action, backoff_type, max_tries } = get(currentPageTemplate, 'auto_action', {
      delay_in_ms: null,
      action: null,
      backoff_type: null,
      max_tries: null
    })

    // not applicable for scheduling action
    if (error || !delay_in_ms || !action) {
      return undefined
    }
    const request = actionMap[action]

    function scheduleAction() {
      return setTimeout(async () => {
        await request({
          ...latestProps.current,
          currentPageTemplate,
          error,
          delayInMs: delay_in_ms,
          backOffType: backoff_type,
          maxTries: max_tries,
        })
      }, delay_in_ms)
    }

    const timeoutId = scheduleAction()

    return () => timeoutId && clearTimeout(timeoutId)
  }, [currentPageTemplate, error])
}

const updateOnboardingRequest = ({
  uniqueLink,
  currentPageTemplate,
  template,
  currentStep,
  updateOnboarding,
}) => {
  updateOnboarding(
    uniqueLink,
    currentPageTemplate.template_response_data,
    currentPageTemplate,
    {
      workflowId: template.template_id,
      stepName: currentPageTemplate.step_name || currentStep,
      uniqueLink,
      pageId: currentPageTemplate.page_id,
    },
    {}
  )
}

const getOnboardingRequest = ({
  getOnboarding,
  uniqueLink,
  signupCountryCode,
}) => {
  getOnboarding(uniqueLink, signupCountryCode)
}

const pollGetOnboarding = ({
  pollGetOnboarding,
  uniqueLink,
  signupCountryCode,
  delayInMs,
  backOffType,
  maxTries,
}) => {
  pollGetOnboarding(uniqueLink, signupCountryCode, false, {
    delayInMs,
    backOffType,
    remainingTries: maxTries,
  })
}

const actionMap = {
  updateOnboarding: updateOnboardingRequest,
  getOnboarding: getOnboardingRequest,
  pollGetOnboarding,
}

export default useScheduleAction
